import { render } from "./ManPages.vue?vue&type=template&id=fcdc9cfa&scoped=true"
import script from "./ManPages.vue?vue&type=script&lang=js"
export * from "./ManPages.vue?vue&type=script&lang=js"

import "./ManPages.vue?vue&type=style&index=0&id=fcdc9cfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcdc9cfa"]])

export default __exports__